import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: max-content;
`;

export const SectionTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const FileSelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileSelectLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: block;
`;

export const FileSelectWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;
`;

export const FileSelect = styled.select`
  width: 100%;
  min-width: 250px;
  max-width: 350px;
  height: 50px;
  border-radius: 6px;
  background: #efefef;
  border: 2px solid ${({ hasValue }) => hasValue ? '#009444' : '#efefef'};
  padding: 12px 18px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #000000;
  cursor: pointer;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  option {
    background: #ffffff;
    color: #000000;
  }
`;

export const ColumnSelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ColumnSelectHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ColumnSelectLabel = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const AnalyzeButton = styled.button`
  width: 120px;
  height: 40px;
  border-radius: 6px;
  background: #6A42F2;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: opacity 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const FileStatusBox = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #dddddd;
  display: flex;
  align-items: center;
  padding: 20px;
`;

export const FileStatusText = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColumnConfigGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ColumnConfigTitle = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const ColumnConfigBox = styled.div`
  width: 100%;
  min-height: auto;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #dddddd;
  padding: 24px;
`;

export const SelectAllWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #767676;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:checked {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
`;

export const CheckboxLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ColumnItemsTitle = styled.h4`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  margin: 16px 0;
  display: flex;
  align-items: center;
`;

export const ColumnList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const ColumnItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
`;

export const FileNameGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileNameLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: block;
`;

export const FileNameInput = styled.input`
  width: 100%;
  max-width: 500px;
  height: 44px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #000000;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #999999;
  }
`;

export const PreviewGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviewLabel = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const PreviewBox = styled.div`
  width: 100%;
  min-height: 300px;
  height: auto;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  overflow: auto;
  padding: 16px;
`;

export const PreviewEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
`;

export const PreviewTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 14px;
`;

export const PreviewTableHeader = styled.thead`
  background: #f9fafb;
`;

export const PreviewTableHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  color: #333333;
  font-weight: 600;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  line-height: 20px;
`;

export const PreviewTableBody = styled.tbody``;

export const PreviewTableCell = styled.td`
  padding: 10px 16px;
  color: #666666;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  line-height: 20px;
`;

export const SelectedCount = styled.span`
  margin-left: 8px;
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;


export const ErrorMessage = styled.div`
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0;
`;

export const PreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;



export const ExecuteButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;


export const SelectedNodesSection = styled.div`
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const SelectedNodesTitle = styled.h4`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0 0 12px 0;
`;

export const SelectedNodeItem = styled.div`
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  color: #0c4a6e;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
`;

// 🆕 로딩 관련 스타일
export const LoadingMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f3f4f6;
  border-top: 3px solid #6A42F2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
`;

// 🆕 디버깅 정보 스타일 (기존 인라인 스타일을 styled-component로 변경)
export const DebugInfo = styled.div`
  background: #f0f0f0;
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: #666666;
  border-left: 3px solid #6A42F2;
`;

// 🔧 기존 EmptyColumnsMessage 스타일 개선
export const EmptyColumnsMessage = styled.div`
  text-align: center;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 40px 20px;
  
  &::before {
    content: "📄";
    display: block;
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
`;

// TrimModal.style.js에 추가해야 할 누락된 스타일들

// 🆕 컬럼명 지정하기 관련 추가 스타일
export const ColumnCount = styled.span`
  color: #6A42F2;
  font-size: 16px;
  font-weight: 500;
  margin-left: 8px;
`;

export const ColumnConfigDescription = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin: 12px 0 20px 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #475569;
`;

export const DescriptionIcon = styled.div`
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const ExampleText = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: #64748b;
  
  strong {
    color: #6A42F2;
    background: #f1f0ff;
    padding: 2px 4px;
    border-radius: 3px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const PreviewIcon = styled.span`
  margin-right: 8px;
`;

export const ModificationStats = styled.div`
  background: #dbeafe;
  color: #1e40af;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

// 기존 ColumnPreviewTable에 높이 제한 및 스크롤 추가
export const ColumnPreviewTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  
  /* 🆕 스크롤 기능 추가 */
  display: block;
  max-height: 400px;
  overflow-y: auto;
  
  /* 🆕 가로 고정 레이아웃 */
  table-layout: fixed;
`;

// ColumnPreviewHeader를 sticky로 고정
export const ColumnPreviewHeader = styled.thead`
  background: #f9fafb;
  position: sticky;
  top: 0;
  z-index: 1;
  display: table-header-group;
  
  /* 🆕 헤더 너비 고정 */
  width: 100%;
`;

export const ColumnPreviewBody = styled.tbody`
  display: table-row-group;
  width: 100%;
`;

// 헤더 셀들의 너비 비율 지정
export const ColumnPreviewHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  
  /* 🆕 너비 비율 고정 */
  width: 40%;
  word-wrap: break-word;
  overflow: hidden;
`;

export const ArrowHeaderCell = styled.th`
  padding: 12px 8px;
  text-align: center;
  color: #6b7280;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  
  /* 🆕 고정 너비 */
  width: 8%;
`;

export const StatusHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: center;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  
  /* 🆕 고정 너비 */
  width: 12%;
`;




export const ColumnPreviewRow = styled.tr`
  ${({ modified }) => modified && `
    background: #fffbeb;
    
    &:hover {
      background: #fef3c7;
    }
  `}
  
  &:nth-of-type(even):not([modified]) {
    background: #f9fafb;
  }
  
  &:hover:not([modified]) {
    background: #f3f4f6;
  }
  
  transition: background-color 0.2s ease;
`;

export const ColumnPreviewCell = styled.td`
  padding: 10px 16px;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 18px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
  
  /* 🆕 너비 고정 및 텍스트 처리 */
  width: 40%;
  word-wrap: break-word;
  overflow: hidden;
  
  ${({ highlighted }) => highlighted && `
    background: #ecfdf5;
    color: #047857;
    font-weight: 500;
  `}
`;

export const ArrowCell = styled.td`
  padding: 10px 8px;
  text-align: center;
  font-size: 16px;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
  width: 8%;
`;

export const StatusCell = styled.td`
  padding: 10px 16px;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
  width: 12%;
`;

export const PathText = styled.span`
  ${({ truncated }) => truncated && `
    display: block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;


export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  ${({ modified }) => modified ? `
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fbbf24;
  ` : `
    background: #f3f4f6;
    color: #6b7280;
    border: 1px solid #d1d5db;
  `}
`;

export const ColumnNamingTip = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 6px;
  padding: 12px 16px;
  margin-top: 16px;
  color: #0c4a6e;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 18px;
  
  strong {
    color: #075985;
  }
`;

export const TipIcon = styled.span`
  font-size: 16px;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const HeaderRowsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HeaderRowsLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: block;
`;

export const HeaderRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100px;
  padding: 12px 16px;
  border: 2px solid #dddddd;
  border-radius: 6px;
  background: #ffffff;
  transition: border-color 0.2s ease;
  
  &:focus-within {
    border-color: #6A42F2;
    box-shadow: 0 0 0 3px rgba(106, 66, 242, 0.1);
  }
  
  &:hover {
    border-color: #6A42F2;
  }
`;

export const HeaderRowsInput = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 16px;
  color: #333333;
  width: 100%;
  text-align: center;
  height: 20px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  
  &::placeholder {
    color: #ccc;
  }
  
  &:disabled {
    color: #999999;
    cursor: not-allowed;
  }
`;

export const HeaderRowsHint = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px 12px;
  
  /* 이모지와 텍스트 정렬 */
  &::before {
    content: '';
    flex-shrink: 0;
  }
  
  /* 반응형 */
  @media (max-width: 480px) {
    font-size: 11px;
    line-height: 16px;
    padding: 6px 10px;
  }
`;

export const ColumnConfigSubTitle = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  line-height: 5px;
  font-weight: 400;
  margin: 2px 0 0 0;
`;


export const FileNameSubLabel = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  line-height: 4px;
  font-weight: 400;
  margin: 3px 0 4px 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

// PreviewButton 스타일 수정
export const PreviewButton = styled.button`
  width: 100px;
  height: 40px;
  padding: 8px 16px;
  background: #10b981;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    background: #059669;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// ExecuteButton 스타일 수정 (기존과 동일한 크기로)
export const ExecuteButton = styled.button`
  width: 100px;
  height: 40px;
  padding: 8px 16px;
  background: #6A42F2;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    background: #5936e8;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;